import { render, staticRenderFns } from "./RentDetail.vue?vue&type=template&id=0b3cd65a&scoped=true&xmlns%3Av-lazy=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./RentDetail.vue?vue&type=script&lang=js&"
export * from "./RentDetail.vue?vue&type=script&lang=js&"
import style0 from "./RentDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./RentDetail.vue?vue&type=style&index=1&id=0b3cd65a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3cd65a",
  null
  
)

export default component.exports